export default __webpack_public_path__ + "static/media/nft-failed.d483cbde.svg";